import React, { Component, useState, useMemo, Fragment } from "react";
import { styled } from '@mui/material/styles';
import { Grid, Tabs, Tab, CssBaseline, Container, AppBar, Divider, Tooltip } from '@mui/material/';
import {
    DataGrid, GridToolbar, plPL, getGridStringOperators, GridActionsCellItem,
    GridToolbarContainer,
    GridToolbarColumnsButton,
    GridToolbarFilterButton,
    GridToolbarExport,
    GridToolbarDensitySelector,
} from '@mui/x-data-grid';
import { query, flattenObj, TokenData } from '../App';
import { renderEmail } from '@mui/x-data-grid-generator/renderer';
import SearchIcon from '@mui/icons-material/Search';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import { Navigate, Link } from "react-router-dom";
import config from '../config/default.json';
import { Dialog, DialogActions, DialogTitle, Box, Button } from '@mui/material';
import { Plus } from 'tabler-icons-react';


const filterOperators = getGridStringOperators().filter(({ value }) =>
    ['equals', 'contains', 'startsWith', 'endsWith' /* add more over time */].includes(value),
);

export default function DefaultDataGrid(props) {
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [dialogState, setDialogState] = useState({ open: false, id: undefined });
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [pageSize, setPageSize] = useState(100);
    const [page, setPage] = useState(0);
    const [rowCount, setRowCount] = useState(0);
    const [skipRows, setSkipRows] = useState(0);
    const [filterData, setfilterData] = useState({});
    const [sortModel, setSortModel] = useState(props.sortmodel ? props.sortmodel : { field: 'id', sort: 'desc' });
    const [columnVisibility, setColumnVisibility] = useState(props.columns.map(e => ({ "id": e.field, "hidden": e.hide ? false : true }))
        .reduce((acc, currentObject) => {
            acc[currentObject.id] = currentObject.hidden;
            return acc;
        }, {}));
    const { columns, queryPath, columnGroupingModel } = props;
    const userPermissions = (React.useContext(TokenData)).permissions;

    const onFilterChange = React.useCallback((filterModel) => {
        // Here you save the data you need from the filter model
        filterModel = filterModel.items[0]
        console.log(filterModel)
        setfilterData(filterModel);
        //setQueryOptions({ filterModel: { ...filterModel } });
    }, []);

    const handleSortModelChange = React.useCallback((sortModel) => {
        console.log(sortModel)
        console.log(columnVisibility)
        // Here you save the data you need from the sort model
        setSortModel(sortModel[0]);
    }, []);

    const handleDeleteClick = React.useCallback((id) => () => setDialogState({ open: true, id: id }));

    const columnsRender = React.useMemo(() => {
        let a = columns.map(c => Object.assign(c, filterOperators));
        return a.concat([
            {
                field: 'actions',
                type: 'actions',
                minWidth: 230,
                flex: 1,
                cellClassName: 'actions',//handleDeleteClick(id) handleEditClick(id)
                getActions: (params) => {
                    const defaultActions = [<GridActionsCellItem
                        icon={<Tooltip arrow title={`Pogląd id: ${params.id}`}><SearchIcon /></Tooltip>}
                        label="Otworz"
                        component={Link} to={`${queryPath}/${params.id}/lookup`}
                        className="textPrimary"
                        color="inherit"
                    />]
                    const editAction = <GridActionsCellItem
                        icon={<Tooltip arrow title={`Edytuj id: ${params.id}`}><EditIcon /></Tooltip>}
                        label="Edytuj"
                        component={Link} to={`${queryPath}/${params.id}/edit`}
                        className="textPrimary"
                        color="inherit"
                    />;
                    const deleteAction = <GridActionsCellItem
                        icon={<Tooltip arrow title={`Usunięcie id: ${params.id}`}><DeleteIcon /></Tooltip>}
                        label="Usun"
                        onClick={handleDeleteClick(params.id)}
                        color="inherit"
                    />;

                    if (userPermissions[queryPath.substr(1)]['edit'] || userPermissions.admin) {
                        if (props.editButton !== false) defaultActions.push(editAction);
                        defaultActions.push(deleteAction);
                    }
                    if (props.additionalActionButtons) return (props.additionalActionButtons.map(e => <GridActionsCellItem
                        icon={<Tooltip arrow title={e.iconTooltip.replace(`*id*`, params.id)}><e.icon /></Tooltip>}
                        label={e.label}
                        component={e.linkTo && Link} to={e.linkTo && e.linkTo.replace(`*id*`, params.id)}
                        onClick={e.onClick && (() => e.onClick(params.id))}
                        className="textPrimary"
                        color="inherit"
                    />)).concat(defaultActions)
                    return defaultActions;
                }
            }
        ])
    }, [handleDeleteClick])

    useMemo(() => {
        if (!filterData) return;
        console.log(filterData)
        var { columnField, operatorValue, value } = filterData;
        if (filterData.field) {
            var { field: columnField } = filterData;
        }
        if (filterData.operator) {
            var { operator: operatorValue } = filterData;
        }
        console.log(operatorValue);
        setLoading(true);
        let filterModel = []
        if (props.filterData) Array.isArray(props.filterData) ? filterModel = props.filterData : filterModel.push(props.filterData);
        if (columnField && operatorValue && value) filterModel.push({
            field: columnField,
            operator: operatorValue,
            value: value
        })
        console.log({
            limit: pageSize,
            skip: skipRows,
            sortModel: sortModel,
            filterModel: filterModel
        })
        return query(`${queryPath}/search`, 'POST', {
            limit: paginationModel.pageSize,
            skip: paginationModel.page * paginationModel.pageSize,
            sortModel: sortModel,
            filterModel: filterModel
        }, alert = false)
            .then(res => {
                if (res.rows) setRows(res.rows.map(e => {
                    e.id = e._id;
                    delete e._id;
                    return Object.assign(flattenObj(e), e);
                }));
                else setRows([]);
                setRowCount(res.count);
                setLoading(false);
            })
    }, [paginationModel, filterData, sortModel])

    const handleDialogClose = (bool) => setDialogState({ ...dialogState, open: false, });

    // const [rowCountState, setRowCountState] = useState(0);
    // useEffect(() => {
    //     setRowCountState((prevRowCountState) =>
    //         rowCount !== undefined ? rowCount : prevRowCountState
    //     );
    // }, [rowCount]);

    const handleDialogAgree =
        (bool) => query(props.queryPath, 'delete', { id: dialogState.id }).then(res => {
            setRows(rows.filter((row) => row.id !== dialogState.id));
            setDialogState({ open: false, id: undefined });
        })

    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarColumnsButton />
                <Divider orientation="vertical" variant="middle" flexItem />
                <GridToolbarFilterButton />
                <Divider orientation="vertical" variant="middle" flexItem />
                <GridToolbarDensitySelector />
                <Divider orientation="vertical" variant="middle" flexItem />
                <GridToolbarExport />
                {
                    (props.addingTool === undefined || props.addingTool === true) && <Fragment>
                        <Divider orientation="vertical" variant="middle" flexItem />
                        <Button startIcon={<Plus size={20} />} component={Link} to={`${queryPath}/add`}>Dodaj</Button>
                    </Fragment>
                }
            </GridToolbarContainer>
        );
    }

    return (
        <React.Fragment>
            <DataGrid
                sx={{
                    height: '90vh',
                    padding: "20px",
                    backgroundColor: "white",
                    border: "none",
                    borderRadius: "10px",
                    ".MuiDataGrid-row.Mui-odd ": {
                        backgroundColor: 'rgb(231 231 231 / 87%)'
                    }
                }}
                getRowClassName={(params) =>
                    params.indexRelativeToCurrentPage % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                }
                localeText={plPL.components.MuiDataGrid.defaultProps.localeText}
                components={{ Toolbar: CustomToolbar, NoRowsOverlay: CustomNoRowsOverlay }}
                pageSize={pageSize}
                pageSizeOptions={[25, 50, 100]}
                page={page}
                onPageSizeChange={(newPageSize) => !loading && setPageSize(newPageSize)}
                paginationModel={paginationModel}
                onPaginationModelChange={setPaginationModel}
                rows={rows}
                experimentalFeatures={{ columnGrouping: true }}
                columnGroupingModel={columnGroupingModel}
                loading={loading}
                rowCount={rowCount}
                paginationMode="server"
                filterMode="server"
                sortingMode="server"
                onSortModelChange={handleSortModelChange}
                onFilterModelChange={onFilterChange}
                {...props}
                columns={columnsRender}
                columnVisibilityModel={columnVisibility}
                componentsProps={{
                    panel: {
                        sx: {
                            top: '-120px !important',
                        },
                    },
                }}
            />
            <Dialog
                open={dialogState.open}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Czy na pewno chcesz usunąć id: " + dialogState.id}
                </DialogTitle>
                <DialogActions>
                    <Button onClick={handleDialogClose}>Anuluj</Button>
                    <Button onClick={handleDialogAgree} autoFocus>
                        Zatwierdz
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}




const StyledGridOverlay = styled('div')(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    '& .ant-empty-img-1': {
        fill: theme.palette.mode === 'light' ? '#aeb8c2' : '#262626',
    },
    '& .ant-empty-img-2': {
        fill: theme.palette.mode === 'light' ? '#f5f5f7' : '#595959',
    },
    '& .ant-empty-img-3': {
        fill: theme.palette.mode === 'light' ? '#dce0e6' : '#434343',
    },
    '& .ant-empty-img-4': {
        fill: theme.palette.mode === 'light' ? '#fff' : '#1c1c1c',
    },
    '& .ant-empty-img-5': {
        fillOpacity: theme.palette.mode === 'light' ? '0.8' : '0.08',
        fill: theme.palette.mode === 'light' ? '#f5f5f5' : '#fff',
    },
}));

function CustomNoRowsOverlay() {
    return (
        <StyledGridOverlay>
            <svg
                width="120"
                height="100"
                viewBox="0 0 184 152"
                aria-hidden
                focusable="false"
            >
                <g fill="none" fillRule="evenodd">
                    <g transform="translate(24 31.67)">
                        <ellipse
                            className="ant-empty-img-5"
                            cx="67.797"
                            cy="106.89"
                            rx="67.797"
                            ry="12.668"
                        />
                        <path
                            className="ant-empty-img-1"
                            d="M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z"
                        />
                        <path
                            className="ant-empty-img-2"
                            d="M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"
                        />
                        <path
                            className="ant-empty-img-3"
                            d="M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z"
                        />
                    </g>
                    <path
                        className="ant-empty-img-3"
                        d="M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z"
                    />
                    <g className="ant-empty-img-4" transform="translate(149.65 15.383)">
                        <ellipse cx="20.654" cy="3.167" rx="2.849" ry="2.815" />
                        <path d="M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z" />
                    </g>
                </g>
            </svg>
            <Box sx={{ mt: 1 }}>Nie znaleziono</Box>
        </StyledGridOverlay>
    );
}